/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

export function expandItem(item) {
  return (dispatch) => dispatch({ item, type: Types.EXPAND_ITEM });
}
export function toggleExpandedItem(item) {
  return (dispatch) => dispatch({ item, type: Types.TOGGLE_EXPANDED_ITEM });
}

export function collapseItem(item) {
  return (dispatch) => dispatch({ item, type: Types.COLLAPSE_ITEM });
}

export function addListSize(id, height, width) {
  return (dispatch) =>
    dispatch({ newList: { id, height, width }, type: Types.ADD_LIST_SIZE });
}

export function removeListSize(id) {
  return (dispatch) => dispatch({ listId: id, type: Types.REMOVE_LIST_SIZE });
}
